import { render } from "./new-joiners.vue?vue&type=template&id=cb46a95c"
import script from "./new-joiners.vue?vue&type=script&lang=js"
export * from "./new-joiners.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__